import { type ContentComponent, type SiteWideSaleSection } from '../../../../types/construct.types';

export const SiteWideSaleSectionHandler: ContentComponent<SiteWideSaleSection> = ({
	content: {
		fields: { heading, related_categories }
	},
	renderer
}) => {
	return related_categories.items.length ? (
		<section className="w-100">
			{heading && <h2 className="tc">{heading}</h2>}
			{renderer.render(related_categories, undefined, { ListContent: { totalItemCount: related_categories.items.length } })}
		</section>
	) : null;
};
